import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import cx from 'classnames';

import messages from '../../MLSummary.messages'
import styles from '../../MLSummary.module.scss'

function MLHOPCoverages({ data, fullTermCost_Ext, show,preQualHomeOccupancy,isModernProduct }) {
    const translator = useTranslator();

    if (_.isEmpty(data)) {
        return null;
    }

    const generateHeader = () => {
        return (
            <thead>
                <tr>
                    <th>{translator(messages.Coverage)}</th>
                    <th>{translator(messages.LimitAndDeductible)}</th>
                </tr>
            </thead>
        );
    }

    if (show) {
        return (
            <div className="vertical-spacing-40">
                <h2 className="section-header vertical-spacing-20">
                    {translator(messages.Coverages)}
                </h2>
                <table className={cx('table table-striped table-bordered table-data-vertical', styles.coveragesTable, styles.noLeftRightBorders)}>
                    {generateHeader()}
                    {data.map((coverage) => {
                        return (
                            <>
                                <tbody>
                                    <tr />
                                    {(coverage.selected)?
                                        <tr>
                                            <td colSpan="2">
                                                <h2 className="subsection-header">{coverage.name}</h2>
                                            </td>
                                        </tr> : <></>
                                    }
                                    {coverage.terms.map((term) => {

                                        const isSecondaryOrSeasonalModernHome =
                                            isModernProduct &&
                                            [
                                                'HOPPreQualHomeCondoOccupancySecondary',
                                                'HOPPreQualHomeCondoOccupancySeasonal'
                                            ].includes(preQualHomeOccupancy);

                                        const isCoverageEorF =
                                            ['HOPCovE', 'HOPCovF'].includes(coverage.code_ML);

                                        const showExtendedToPrimary =
                                            isSecondaryOrSeasonalModernHome && isCoverageEorF;

                                        return (
                                            (coverage.selected && term.isVisible_ML) ?
                                                <tr>
                                                    <td className="col-sm-3 sub-cell"><strong>{showExtendedToPrimary ? 'Extended to Primary'
                                                        : term.name}</strong></td>

                                                    {!showExtendedToPrimary && (
                                                        <td>{term.chosenTermValue}</td>
                                                    )}

                                                </tr> : <></>
                                        );
                                    })}
                                </tbody>
                            </>
                        );
                    })}
                    <tfoot>
                        <tr>
                            <td colSpan="2">
                                <strong>{translator(messages.CoverageTotal)}</strong>
                                <span className="coverage-total-text">
                                    <strong>{fullTermCost_Ext}</strong>{translator(messages.YearTerm)}
                                </span>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        );
    }
    return ( <></> );
}

MLHOPCoverages.propTypes = {
    data: PropTypes.shape([]),
    fullTermCost_Ext: PropTypes.number,
    show: PropTypes.bool
};
MLHOPCoverages.defaultProps = {
    data: [],
    fullTermCost_Ext: 0,
    show: false
};
export default MLHOPCoverages;
